import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}
		
  editAddress(address) {
    address.type="secondaryAddresses";
    address.primary=false;
    if(address._links){
      delete address._links;
    }
    address={items:[address]};
          
      return this.http.post(environment.ECARE_URL
         +'eshop/checkout',address,
         this.httpOptions);
  }

  submitOrder(order) {
    
    var locale={
        "locale":"EN"//$rootScope.currentLanguage.toUpperCase()
    }
    var isWebView = sessionStorage.getItem('isWebView')=='true'?true:false;
    var request={"localeObject":locale,
        "isWebView":isWebView}
    if(isWebView){
      var config = {
            headers: {
                'Channel': 'MobileWebView'
            }
        }
      return this.http.post(environment.ECARE_URL
         +'/eshop/checkout',request,config);
    }else{
      return this.http.post(environment.ECARE_URL
         +'/eshop/checkout',request);
    }
  }

  saveShippmentGroups (selectedAddress,personalInfo) {
    selectedAddress.firstName = personalInfo.firstName;
    selectedAddress.lastName = personalInfo.lastName;
    selectedAddress.email = personalInfo.email;
    selectedAddress.mobileNo = personalInfo.mobileNo;
    selectedAddress.documentId = personalInfo.documentId;
    selectedAddress.documentExpiryDate = personalInfo.docExpiryDate;
    selectedAddress.dateOfBirth = personalInfo.dateOfBirth;
    return this.http.post(environment.ECARE_URL
        + 'eshop/saveShippmentGroups', selectedAddress);
  }

  storeSelectedAddress (selectedAddress) {

    return this.http.post(environment.ECARE_URL

        + 'eshop/storeSelectedAddress', selectedAddress);
  }

}
